export default "/_next/static/images/bamboo-b5ffabea20a85b4566f9409812ca6aba.png";